import { createContext } from 'solid-js'

export const PageContext = createContext<string>()
